// 3, 4, 6, or 8 hex digits, with an optional leading `#`. 4 and 8 cover
// the alpha-channel variants. Case-insensitive.
const HEX_RE = /^#?(?:[0-9a-f]{3,4}|[0-9a-f]{6}|[0-9a-f]{8})$/i;

/**
 * Coerce a query-string color value into a `#`-prefixed hex string.
 *
 * Returns `null` for empty, missing, or non-hex input. Closes the
 * v-html SVG XSS surface flagged in REVIEW.md §2 P1: previously this
 * function just stripped one `#` and prepended one back, so payloads
 * like `"><script>` flowed through to fill attributes interpolated
 * into v-html and rendered as injected markup.
 */
export const validateHex = (hex) => {
  if (!hex || hex === '') return null;
  if (!HEX_RE.test(hex)) return null;
  return `#${hex.replace('#', '')}`;
};

/**
 * Parse a #RRGGBB / #RGB hex color into a CSS `rgba(...)` string with the
 * given alpha. Falls back to a neutral grey for empty/missing input rather
 * than throwing — every theme-color caller can hand us `null` after
 * validateHex rejects an invalid query-string input.
 *
 * Lifted from v4-components/Controls/Scrubber.vue (REVIEW.md §1 P1 new).
 * Unit-testable here in a way the Vue method couldn't be.
 */
export const hexToRgba = (hex, alpha = 1.0) => {
  const safe = hex || '#888888';
  let color = safe.startsWith('#') ? safe.slice(1) : safe;

  // Expand shorthand #RGB → #RRGGBB
  if (color.length === 3) {
    color = color.split('').map((c) => c + c).join('');
  }

  const num = parseInt(color, 16);
  const r = (num >> 16) & 255;
  const g = (num >> 8) & 255;
  const b = num & 255;

  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
};
